import { render, staticRenderFns } from "./StaffInformation.vue?vue&type=template&id=72e0d2ba&scoped=true"
import script from "./StaffInformation.vue?vue&type=script&lang=js"
export * from "./StaffInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e0d2ba",
  null
  
)

export default component.exports